import { Link } from "react-router-dom";

const columns = [
  {
    title: "Marketplace",
    links: [
      { label: "About TAZY CART", to: "/about" },
      { label: "Marketplace rules", to: "/marketplace-rules" },
      { label: "Order protection", to: "/order-protection" },
      { label: "Dispute support", to: "/dispute-support" },
    ],
  },
  {
    title: "Trade",
    links: [
      { label: "Verified sellers", to: "/sellers" },
      { label: "Start sourcing", to: "/request" },
      { label: "Seller verification", to: "/seller-verification" },
      { label: "Business solutions", to: "/business-solutions" },
    ],
  },
  {
    title: "Fulfilment",
    links: [
      { label: "Transporters", to: "/transporters" },
      { label: "Courier network", to: "/courier-help" },
      { label: "Delivery updates", to: "/order-protection" },
      { label: "Contact support", to: "/contact" },
    ],
  },
  {
    title: "Help",
    links: [
      { label: "Buyer help", to: "/buyer-help" },
      { label: "Seller help", to: "/seller-help" },
      { label: "Courier help", to: "/courier-help" },
      { label: "Privacy policy", to: "/privacy" },
    ],
  },
];

const legalLinks = [
  { label: "Privacy Policy", to: "/privacy" },
  { label: "Terms & Conditions", to: "/terms" },
  { label: "Listing policy", to: "/marketplace-rules" },
];

function FooterLink({ to, children, className }) {
  return (
    <Link className={className} to={to} onClick={() => window.scrollTo({ top: 0, left: 0, behavior: "auto" })}>
      {children}
    </Link>
  );
}

export default function Footer() {
  return (
    <footer className="footer footer-v3">
      <div className="container footer-v3__main">
        <div className="footer-v3__brand">
          <FooterLink to="/" className="footer-v3__logo">
            <img src="/tazy-logo.jpeg" alt="TAZY CART" />
            <span>
              <strong>TAZY CART</strong>
              <small>Shop smart. Live better.</small>
            </span>
          </FooterLink>
          <p>
            A connected marketplace for product discovery, verified sellers, transporter services,
            buyer requests, order tracking and business operations.
          </p>
          <div className="footer-v3__actions">
            <FooterLink to="/register?type=BUYER">Create buyer account</FooterLink>
            <FooterLink to="/register?type=SELLER">Start selling</FooterLink>
          </div>
        </div>

        <nav className="footer-v3__columns" aria-label="Footer navigation">
          {columns.map((col) => (
            <div key={col.title}>
              <h4>{col.title}</h4>
              {col.links.map((link) => (
                <FooterLink to={link.to} key={link.label}>{link.label}</FooterLink>
              ))}
            </div>
          ))}
        </nav>
      </div>

      <div className="container footer-v3__trust">
        <span>Verified sellers</span>
        <span>Order records</span>
        <span>Payment tracking</span>
        <span>Transporter network</span>
        <span>Business subscriptions</span>
      </div>

      <div className="footer-bottom footer-bottom-v3">
        <div>
          <span>© 2026 TAZY CART Marketplace</span>
          <span className="footer-legal-links">
            {legalLinks.map((link) => (
              <FooterLink key={link.label} to={link.to}>{link.label}</FooterLink>
            ))}
          </span>
        </div>
        <span>
          Developed by{" "}
          <a href="https://bronixtechnologies.com" target="_blank" rel="noreferrer">
            Bronix Technologies
          </a>
        </span>
      </div>
    </footer>
  );
}
